import { IconTrash } from "@aksara-ui/icons";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogProps,
  Stack,
  Text,
  theme,
} from "@aksara-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteQuestMission } from "redux/actions/quest";

interface Props {
  missionId: string;
}

const MissionConfirmModal: React.FC<Props & DialogProps> = ({
  isOpen,
  onClose,
  missionId,
}) => {
  const dispatch = useDispatch();
  const { isFormLoading } = useSelector((state: any) => state.questReducer);

  const handleCloseModal = () => {
    onClose && onClose();
  };

  const handleDelete = () => {
    dispatch(deleteQuestMission(missionId, handleCloseModal) as any);
  };

  return (
    <Dialog
      disableOverlayClick
      isOpen={isOpen}
      onClose={() => handleCloseModal()}
    >
      <DialogHeader></DialogHeader>
      <DialogContent>
        <Stack spacing="md" display="flex" flexDirection="column" alignItems="center">
          <Box
            backgroundColor={`${theme.colors.red01}`}
            size={80}
            borderRadius={100}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <IconTrash size={50} fill={`${theme.colors.red05}`} />
          </Box>
          <Text scale={400}>Yakin ingin menghapus quest ini?</Text>
        </Stack>
      </DialogContent>
      <DialogFooter>
        <Stack
          display="flex"
          flexDirection="row"
          spacing="xs"
          flex={1}
          style={{ gap: 15 }}
        >
          <Button variant="outline" block onClick={() => handleCloseModal()}>
            Batal
          </Button>
          <Button
            variant="destructive"
            block
            isLoading={isFormLoading}
            onClick={handleDelete}
          >
            Hapus
          </Button>
        </Stack>
      </DialogFooter>
    </Dialog>
  );
};

export default MissionConfirmModal;
